import { render, staticRenderFns } from "./TeacherSubjectClassCursusAddEdit.vue?vue&type=template&id=ce5812fa"
import script from "./TeacherSubjectClassCursusAddEdit.vue?vue&type=script&lang=js"
export * from "./TeacherSubjectClassCursusAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports